/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadLookupMappingFileResponseContent
 */
export interface UploadLookupMappingFileResponseContent {
    /**
     * 
     * @type {string}
     * @memberof UploadLookupMappingFileResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the UploadLookupMappingFileResponseContent interface.
 */
export function instanceOfUploadLookupMappingFileResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UploadLookupMappingFileResponseContentFromJSON(json: any): UploadLookupMappingFileResponseContent {
    return UploadLookupMappingFileResponseContentFromJSONTyped(json, false);
}

export function UploadLookupMappingFileResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadLookupMappingFileResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UploadLookupMappingFileResponseContentToJSON(value?: UploadLookupMappingFileResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

